import { Loading } from "@/components/Loading/Loading";
import { useOrg } from "@/hooks/org";
import { selectRegion } from "@/store/slices/orgSlice";
import { RootState } from "@/store/store";
import { FC, ReactNode } from "react";
import { useSelector } from "react-redux";

interface Props {
  children: ReactNode;
}

/**
 * Guards rendering children until the current region is available in store.
 */
export const RegionGuard: FC<Props> = ({ children }) => {
  useOrg({ skip: true });

  const region = useSelector((state: RootState) => selectRegion(state));

  if (region === undefined) {
    return <Loading />;
  }

  return <>{children}</>;
};
